import React, { Component } from "react";
import { createRoot } from "react-dom/client";
import Base from "./Base";
import { BrowserRouter as Router } from "react-router-dom";
import "../styles/_base.css";
import "../styles/_buttons.css";
import "../styles/_homepage.css";
import { PersistGate } from "redux-persist/integration/react";
import { Provider } from "react-redux";
import { store, persistor } from "../store/store";

export default class App extends Component {
  render() {
    return (
      <Provider store={store}>
        <Router>
          <PersistGate persistor={persistor}>
            <div style={{ overflowX: "hidden" }}>
              <main>
                <Base />
              </main>
            </div>
          </PersistGate>
        </Router>
      </Provider>
    );
  }
}

// React 18+ root
const appDiv = document.getElementById("app");
const root = createRoot(appDiv);

root.render(<App />);
